import { render, staticRenderFns } from "./profile-gallery.vue?vue&type=template&id=730436c2&scoped=true"
import script from "./profile-gallery.vue?vue&type=script&lang=js"
export * from "./profile-gallery.vue?vue&type=script&lang=js"
import style0 from "./profile-gallery.vue?vue&type=style&index=0&id=730436c2&prod&scoped=true&lang=scss"
import style1 from "./profile-gallery.vue?vue&type=style&index=1&id=730436c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730436c2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InteractiveGallery: require('/app/components/profile/interactive-gallery.vue').default,VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,IconSlider: require('/app/components/v2/icons/IconSlider.vue').default,VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default,IconCatalogCol2: require('/app/components/icons/IconCatalogCol2.vue').default,VBtnToggle: require('/app/node_modules/vuetify/lib/components/VBtnToggle/VBtnToggle.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VBtnToggle,VIcon})
